module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/used_cloth/icon_675685f7ae66135bd7b8876eeaf369c6.png";